module.exports = [
    {
        type: 'title',
        text: 'Highest Gear Privacy Policy',
    },
    {
        type: 'text',
        text: 'This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.',
    },
    {
        type: 'text',
        text: 'We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy. ',
    },
    {
        type: 'group-title',
        text: 'Interpretation and Definitions',
    },
    {
        type: 'subtitle',
        text: 'Interpretation',
    },
    {
        type: 'text',
        text: 'The words of which the initial letter is capitalized have meanings defined under the following conditions.',
    },
    {
        type: 'text',
        text: 'The following definitions shall have the same meaning regardless of whether they appear in singular or plural.',
    },
    {
        type: 'subtitle',
        text: 'Definitions',
    },
    {
        type: 'text',
        text: 'For the purposes of this Privacy Policy:',
    },
    {
        type: 'list',
        items: [
            '<b>You</b> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.',
            '<b>Company</b> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to Highest Gears LLC (or Highest Gear), 15866 Sweet Lemon Way, Winter Garden FL 34787.',
            '<b>Affiliate</b> means an entity that controls, is controlled by, or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest, or other securities entitled to vote for election of directors or other managing authority.',
            '<b>Account</b> means a unique account created for You to access our Service or parts of our Service.',
            '<b>Website</b> refers to Highest Gear, accessible from www.hgrs.us',
            '<b>Service</b> refers to the Website.',
            '<b>Country</b> refers to: United States',
            '<b>Service Provider</b> means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service, or to assist the Company in analyzing how the Service is used.',
            '<b>Third-party Social Media Service</b> refers to any website or any social network website through which a User can log in or create an account to use the Service.',
            '<b>Personal Data</b> is any information that relates to an identified or identifiable individual.\n',
            '<b>Cookies</b> are small files that are placed on Your computer, mobile device, or any other device by a website, containing the details of Your browsing history on that website among its many uses.',
            '<b>Device</b> means any device that can access the Service such as a computer, a cell phone, or a digital tablet.',
            '<b>Usage Data</b> refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).',
        ],
    },
    {
        type: 'title',
        text: 'Collecting and Using Your Personal Data',
    },
    {
        type: 'group-title',
        text: 'Types of Data Collected',
    },
    {
        type: 'subtitle',
        text: 'Personal Data',
    },
    {
        type: 'text',
        text: 'While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:',
    },
    {
        type: 'list',
        items: [
            'Email address',
            'First name and last name',
            'Phone number',
            'Address, State, Province, ZIP/Postal code, City',
            'Usage Data'
        ],
    },
    {
        type: 'subtitle',
        text: 'Usage Data',
    },
    {
        type: 'text',
        text: 'Usage Data is collected automatically when using the Service.',
    },
    {
        type: 'text',
        text: 'Usage Data may include information such as Your Device\'s Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data.',
    },
    {
        type: 'text',
        text: 'When You access the Service by or through a mobile device, We may collect certain information automatically, including, but not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic data.',
    },
    {
        type: 'text',
        text: 'We may also collect information that Your browser sends whenever You visit our Service or when You access the Service by or through a mobile device.',
    },
    {
        type: 'subtitle',
        text: 'Tracking Technologies and Cookies',
    },
    {
        type: 'text',
        text: 'We use Cookies and similar tracking technologies to track the activity on Our Service and store certain information. Tracking technologies used are beacons, tags, and scripts to collect and track information and to improve and analyze Our Service.',
    },
    {
        type: 'text',
        text: 'You can instruct Your browser to refuse all Cookies or to indicate when a Cookie is being sent. However, if You do not accept Cookies, You may not be able to use some parts of our Service.',
    },
    {
        type: 'text',
        text: 'Cookies can be "Persistent" or "Session" Cookies. Persistent Cookies remain on your personal computer or mobile device when You go offline, while Session Cookies are deleted as soon as You close your web browser.',
    },
    {
        type: 'text',
        text: 'We use both session and persistent Cookies for the purposes set out below:',
    },
    {
        type: 'list',
        items: [
            '<b>Necessary / Essential Cookies</b><br/>' +
                'Type: Session Cookies<br/>' +
                'Administered by: Us<br/>' +
                'Purpose: These Cookies are essential to provide You with services available through the Website and to enable You to use some of its features. They help to authenticate users and prevent fraudulent use of user accounts. Without these Cookies, the services that You have asked for cannot be provided, and We only use these Cookies to provide You with those services.',
            '<b>Cookies Policy / Notice Acceptance Cookies</b><br/>' +
                'Type: Persistent Cookies<br/>' +
                'Administered by: Us<br/>' +
                'Purpose: These Cookies identify if users have accepted the use of cookies on the Website.',
            '<b>Functionality Cookies</b><br/>' +
                'Type: Persistent Cookies<br/>' +
                'Administered by: Us<br/>' +
                'Purpose: These Cookies allow us to remember choices You make when You use the Website, such as remembering your login details or language preference. The purpose of these Cookies is to provide You with a more personal experience and to avoid You having to re-enter your preferences every time You use the Website.',

        ],
    },
    {
        type: 'subtitle',
        text: 'Use of Your Personal Data',
    },
    {
        type: 'text',
        text: 'The Company may use Personal Data for the following purposes:',
    },
    {
        type: 'list',
        items: [
            '<b>To provide and maintain our Service,</b> including to monitor the usage of our Service.',
            '<b>To manage Your Account:</b> to manage Your registration as a user of the Service. The Personal Data You provide can give You access to different functionalities of the Service that are available to You as a registered user. For registration, you will have to provide your company name, address, DOT, MC, email address, and the phone number.',
            '<b>For the performance of a contract:</b> the development, compliance, and undertaking of the purchase contract for the products, items, or services You have purchased or of any other contract with Us through the Service.',
            '<b>To contact You:</b> To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication, such as a mobile application\'s push notifications regarding updates or informative communications related to the functionalities, products or contracted services, including the security updates, when necessary or reasonable for their implementation.',
            '<b>To provide You</b> with news, special offers, and general information about other goods, services, and events which we offer that are similar to those that you have already purchased or enquired about unless You have opted not to receive such information.',
            '<b>To manage Your requests:</b> To attend and manage Your requests to Us.',
        ]
    },
    {
        type: 'text',
        text: 'We may share your personal information in the following situations:',
    },
    {
        type: 'list',
        items: [
            '<b>With Service Providers:</b> We may share Your personal information with Service Providers to monitor and analyze the use of our Service, to contact You.',
            '<b>For Business transfers:</b> We may share or transfer Your personal information in connection with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a portion of our business to another company.',
            '<b>With Affiliates:</b> We may share Your information with Our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include Our parent company and any other subsidiaries, joint venture partners, or other companies that We control or that are under common control with Us.',
            '<b>With Business Partners:</b> We may share Your information with Our business partners to offer You certain products, services, or promotions.',
            '<b>With other users:</b> when You share personal information or otherwise interact in the public areas with other users, such information may be viewed by all users and may be publicly distributed outside. If You interact with other users or register through a Third-Party Social Media Service, Your contacts on the Third-Party Social Media Service may see Your name, profile, pictures, and description of Your activity. Similarly, other users will be able to view descriptions of Your activity, communicate with You and view Your profile.',
        ]
    },
    {
        type: 'subtitle',
        text: 'Retention of Your Personal Data',
    },
    {
        type: 'text',
        text: 'The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.',
    },
    {
        type: 'text',
        text: 'The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period, except when this data is used to strengthen the security or to improve the functionality of Our Service, or We are legally obligated to retain this data for longer periods.',
    },
    {
        type: 'subtitle',
        text: 'Transfer of Your Personal Data',
    },
    {
        type: 'text',
        text: 'Your information, including Personal Data, is processed at the Company\'s operating offices and in any other places where the parties involved in the processing are located. It means that this information may be transferred to — and maintained on — computers located outside of Your state, province, country, or other governmental jurisdiction where the data protection laws may differ from those from Your jurisdiction.',
    },
    {
        type: 'text',
        text: 'Your consent to this Privacy Policy followed by Your submission of such information represents Your agreement to that transfer.',
    },
    {
        type: 'text',
        text: 'The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of Your data and other personal information.',
    },
    {
        type: 'group-title',
        text: 'Disclosure of Your Personal Data',
    },
    {
        type: 'subtitle',
        text: 'Business Transactions',
    },
    {
        type: 'text',
        text: 'If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy.',
    },
    {
        type: 'subtitle',
        text: 'Law enforcement',
    },
    {
        type: 'text',
        text: 'Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).',
    },
    {
        type: 'subtitle',
        text: 'Other legal requirements',
    },
    {
        type: 'text',
        text: 'The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:',
    },
    {
        type: 'list',
        items: [
            'Comply with a legal obligation',
            'Protect and defend the rights or property of the Company',
            'Prevent or investigate possible wrongdoing in connection with the Service,',
            'Protect the personal safety of Users of the Service or the public',
            'Protect against legal liability'
        ]
    },
    {
        type: 'subtitle',
        text: 'Security of Your Personal Data',
    },
    {
        type: 'text',
        text: 'Highest Gear will use reasonable technical, administrative, and physical measures to protect information contained in our system against misuse, loss or alteration. All information you provide to us is stored on our secure servers or secured servers licensed for use by us. Highest Gear complies with the Payment Card Industry Data Security Standard (PCI-DSS).',
    },
    {
        type: 'text',
        text: 'Where we have given you (or where you have chosen) a password that enables you to access certain parts of our Processing Services or to engage with our customer service team, you are responsible for keeping this password confidential and adequately complex. We ask you not to share a password with anyone and change your password every 90 days. If we receive instructions using your log-in information we will consider that you have authorized the instructions.',
    },
    {
        type: 'text',
        text: 'Unfortunately, the transmission of information via the Internet is not completely secure. Although we will do our best to protect your Personal data, we cannot guarantee the security of your data transmitted to our Website; any transmission is at your own risk.',
    },
    {
        type: 'text',
        text: 'The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet or method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.',
    },
    {
        type: 'subtitle',
        text: 'Children\'s Privacy',
    },
    {
        type: 'text',
        text: 'Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us. If We become aware that We have collected Personal Data from anyone under the age of 13 without verification of parental consent, We take steps to remove that information from Our servers.',
    },
    {
        type: 'text',
        text: 'If We need to rely on consent as a legal basis for processing Your information and Your country requires consent from a parent, We may require Your parent\'s consent before We collect and use that information.',
    },
    {
        type: 'subtitle',
        text: 'Links to Other Websites',
    },
    {
        type: 'text',
        text: 'Our Service may contain links to other websites that are not operated by Us. If You click on a third party link, You will be directed to that third party\'s site. We strongly advise You to review the Privacy Policy of every site You visit.',
    },
    {
        type: 'text',
        text: 'We have no control over and assume no responsibility for the content, privacy policies, or practices of any third party sites or services.',
    },
    {
        type: 'subtitle',
        text: 'Changes to this Privacy Policy',
    },
    {
        type: 'text',
        text: 'We may update our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page.',
    },
    {
        type: 'text',
        text: 'We will let You know via email and/or a prominent notice on Our Service, before the change becomes effective and update the "Last Updated" date at the top of this Privacy Policy.',
    },
    {
        type: 'text',
        text: 'You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.',
    },
    {
        type: 'group-title',
        text: 'The conflict between this Privacy Policy and the Website Terms and Conditions',
    },
    {
        type: 'text',
        text: 'Where there is a conflict between this Privacy Policy and an explicit provision of the Terms and Conditions or the Website Terms related to our Processing Services, this Privacy Policy will prevail over those other Terms.',
    },
    {
        type: 'subtitle',
        text: 'Additional State-Specific Terms',
    },
    {
        type: 'text',
        text: 'Nevada residents: This notice is provided to you according to state law. Nevada state privacy laws permit us to make marketing calls to existing customers, but if you prefer not to receive marketing calls, you may be placed on our internal opt-out list by emailing us at main@hgrs.us or you may also contact the Nevada Bureau of Consumer Protection, Office of the Nevada Attorney General, 555 E. Washington St., Ste 3900, Las Vegas, NV 89101; telephone 702-486-3132; email: AGCinfo@ag.nv.gov.',
    },
    {
        type: 'text',
        text: 'Texas residents: If you have a complaint, first contact HIghest Gear, at main@hgrs.us. If you still have an unresolved complaint regarding the company’s money transmission or currency exchange activity, please direct your complaint to the Texas Department of Banking: 2601 North Lamar Boulevard, Austin, TX 78705-4294; 1-877-276-5554 (toll-free); www.dob.texas.gov.',
    },
    {
        type: 'text',
        text: 'Vermont residents: Following Vermont law, we will not share information we collect about you with companies outside of Highest Gear except as required or permitted by law. For example, we may share information to service your accounts, complete requested transactions, or to provide rewards or benefits to which you are entitled.',
    },
    {
        type: 'subtitle',
        text: 'California Consumer Privacy Act',
    },
    {
        type: 'text',
        text: 'Under the California Consumer Privacy Act (“CCPA”), and subject to certain limitations and exceptions, if you are a California resident, you may have the following rights with respect to the information we have collected about you that constitutes personal information under the CCPA:',
    },
    {
        type: 'list',
        items: [
            'To request disclosure about our personal information collection practices during the prior 12 months, including the categories of personal information we collected, the sources of the information, our business purposes for collecting or sharing the information and the categories of third parties with whom we shared such information;',
            'To request a copy of the specific pieces of personal information we may have collected about you in the last 12 months;',
            'To request that we delete (and direct our service providers to delete) your personal information, subject to certain exceptions;',
            'To opt-out of any “sales” of your personal information, if a business is selling your information; and',
            'To not be discriminated against for exercising these rights.'
        ]
    },
    {
        type: 'text',
        text: 'To exercise your data protection rights California residents contact us at (email address). If you have questions, please contact us as described in the “Contact Us” section below. You may be required to provide additional information necessary to confirm your identity before we can respond to your request and we will use that information only for that purpose. We may request that you submit a signed statement under penalty of perjury that you are the individual you claim to be. We will acknowledge receipt of your request within 10 days and will endeavor to respond within 45 days of receipt of your request, but if we require more time (up to an additional 45 days) we will notify you of our need for additional time. For requests that we do not sell your information, we will comply with your request within 15 days. We cannot respond to your request or provide you with personal information if we cannot verify your identity and confirm that the personal information relates to you.',
    },
    {
        type: 'text',
        text: 'You may request disclosure of our information collection practices, the information we collected about you, or our sharing practices up to twice within 12 months. You may request that we not sell information or for the deletion of your information at any time.',
    },
    {
        type: 'text',
        text: 'For requests for a copy of the personal information we have collected during the 12 months before your request we will endeavor to provide the information in a readily usable format, including by mailing you a paper copy or providing an electronic copy to your registered account, if you have registered an account with us.',
    },
    {
        type: 'text',
        text: 'For requests for deletion of your information, please understand that California law permits us to retain certain information and not to delete it under certain circumstances. By way of example, we are not required to comply with a request to delete information if (1) the information is necessary for us to (a) complete a transaction for you or otherwise perform a contract; or (b) detect, protect against, or prosecute security incidents, fraud or illegal activity; (2) we use the information only internally in ways reasonably aligned with your expectations as our customer (such as maintaining sales records), and (3) we are required to retain the information to comply with legal obligations. If we receive such a request from you, we will notify any service providers we have engaged to delete your information as well.',
    },
    {
        type: 'text',
        text: 'We will not discriminate against you as a result of your exercise of any of these rights.',
    },
    {
        type: 'text',
        text: 'Selling Information. We do not sell your information for monetary consideration and we do not disclose your information for other valuable considerations. If, in the future, we enter into arrangements that fall within the definition of a “sale” under the CCPA, we will update this Privacy Policy and our compliance with the CCPA.',
    },
    {
        type: 'text',
        text: 'Using an Authorized Agent. You may submit a request through someone holding a formal Power of Attorney. Otherwise, you may submit a request using an authorized agent only if (1) the person is registered with the Secretary of State to do business in California, (2) you provide the authorized agent with signed written permission to make a request, (3) you verify directly with us that you have authorized the person to request on your behalf, (4) you verify your own identity directly with us, and (5) your agent provides us with proof that they are so authorized. We will require the agent to submit proof to us that they have been authorized to make requests on your behalf.',
    },
    {
        type: 'group-title',
        text: 'Contact Us',
    },
    {
        type: 'text',
        text: 'If you have any questions about this Privacy Policy, You can contact us via email: <a href="mailto:info@hgrs.us">info@hgrs.us</a>',
    },



]